import { debounce } from "lodash";
export default {
  inserted: (el, binding) => {
    let delay = binding.args;
    if (!delay) delay = 1000;
    el.addEventListener('click', debounce(binding.value, delay, { leading: true, trailing: false }));
  },
}